module.exports = __webpack_public_path__ + "static/media/struggle person.e500bb0a.svg";